import React from 'react';
import {ApolloProvider, ApolloClient, InMemoryCache} from '@apollo/client';
import {BrowserRouter} from 'react-router-dom';

import QueueProvider from '../App/context/QueueProvider';
import CurrentSongProvider from '../App/context/CurrentSongProvider';
import ObsidianProvider from '../App/context/ObsidianProvider';
import MusicKitProvider from '../App/context/MusicKitProvider';
import {CurrentUserProvider} from '../App/context/CurrentUserProvider';
import possibleTypes from '../../possibleTypes.json';

interface Props {
  children: React.ReactNode;
}

export function AppContext({children}: Props) {
  const client = new ApolloClient({
    uri: process.env.REACT_APP_API_URL + '/graphql',
    credentials: 'include',
    cache: new InMemoryCache({
      possibleTypes,
      resultCaching: true,
    }),
  });

  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <MusicKitProvider>
          <CurrentUserProvider>
            <QueueProvider>
              <CurrentSongProvider>
                <ObsidianProvider>{children}</ObsidianProvider>
              </CurrentSongProvider>
            </QueueProvider>
          </CurrentUserProvider>
        </MusicKitProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
}
